<div class="modal fade" tabindex="-1" [id]="modalId"></div>

<nz-modal
    [(nzVisible)]="isVisible"
    [nzTitle]="'Manage Packages for ' + product?.name"
    (nzOnCancel)="handleCancel()"
    [nzFooter]="null"
    nzWidth="800px">

    <ng-container *nzModalContent>
        @if (!canEdit) {
            <app-unauthorized-access-edit-warning></app-unauthorized-access-edit-warning>
        }
        @if (!showForm) {
            @if (canAdd) {
                <div style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
                    <button nz-button nzType="primary" (click)="addNewPackage()">
                        <span nz-icon nzType="plus"></span> Add New Package
                    </button>
                </div>
            }

            <nz-table #basicTable [nzData]="packages" [nzLoading]="isLoadingPackages || isLoadingData" nzSize="small">
                <thead>
                    <tr>
                        <th>Package Name</th>
                        <th>Included SDKs</th>
                        @if (canEdit) {<th nzAlign="center">Action</th>}
                    </tr>
                </thead>
                <tbody>
                    @for (pkg of basicTable.data; track pkg.id) {
                        <tr>
                            <td>
                                <strong>{{ pkg.name }}</strong>
                                <div style="font-size: 12px; color: #8c8c8c;">{{ pkg.description }}</div>
                            </td>
                            <td>
                                @for (sdk of pkg.sdks; track sdk.id) {
                                    <nz-tag [nzColor]="'processing'" style="margin-bottom: 4px;">{{ sdk.name }}</nz-tag>
                                }
                            </td>
                            @if (canEdit) {
                                <td nzAlign="center">
                                    <button nz-button nzType="default" nzSize="small" (click)="editPackage(pkg)">
                                        <span nz-icon nzType="edit"></span> Edit
                                    </button>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </nz-table>
        }

        @if (showForm) {
            <form nz-form [formGroup]="form" [nzLayout]="'vertical'">
                
                <nz-form-item>
                    <nz-form-label nzRequired>Package Name</nz-form-label>
                    <nz-form-control nzErrorTip="Name is required">
                        <input nz-input formControlName="name" placeholder="e.g., BioWolf Dez 2 (Suprema Edition)" />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>Description</nz-form-label>
                    <nz-form-control>
                        <textarea nz-input formControlName="description" rows="2" placeholder="Optional details..."></textarea>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label nzRequired>Included SDKs</nz-form-label>
                    <nz-form-control nzErrorTip="Please select at least one SDK">
                        
                        <div style="display: flex; gap: 8px; margin-bottom: 8px;">
                            <nz-select 
                                style="flex: 1;" 
                                nzPlaceHolder="Filter by Category" 
                                nzAllowClear 
                                [(ngModel)]="categoryFilter" 
                                [ngModelOptions]="{standalone: true}" 
                                (ngModelChange)="onFilterChange()">
                                @for (cat of categories; track cat.id) {
                                    <nz-option [nzLabel]="cat.name || ''" [nzValue]="cat.id"></nz-option>
                                }
                            </nz-select>

                            <nz-select 
                                style="flex: 1;" 
                                nzPlaceHolder="Filter by Vendor" 
                                nzAllowClear 
                                [(ngModel)]="vendorFilter" 
                                [ngModelOptions]="{standalone: true}" 
                                (ngModelChange)="onFilterChange()">
                                @for (ven of vendors; track ven.id) {
                                    <nz-option [nzLabel]="ven.name || ''" [nzValue]="ven.id"></nz-option>
                                }
                            </nz-select>
                        </div>

                        <nz-select 
                            nzMode="multiple" 
                            nzPlaceHolder="Search and select SDKs..." 
                            formControlName="sdkIds"
                            nzShowSearch
                            [nzFilterOption]="customSearchFn">
                            
                            @for (sdk of filteredSdks; track sdk.id) {
                                <nz-option 
                                    [nzLabel]="sdk.name + (sdk.vendor?.name ? ' (' + sdk.vendor?.name + ')' : '')" 
                                    [nzValue]="sdk.id" 
                                    nzCustomContent>
                                    
                                    <div style="display: flex; align-items: center; justify-content: space-between;">
                                        <span style="font-weight: 500;">{{ sdk.name }}</span>
                                        <span>
                                            @if (sdk.category?.name) {
                                                <nz-tag [nzColor]="sdk.category?.colour">{{ sdk.category?.name }}</nz-tag>
                                            }
                                            @if (sdk.vendor?.name) {
                                                <nz-tag [nzColor]="sdk.vendor?.colour">{{ sdk.vendor?.name }}</nz-tag>
                                            }
                                        </span>
                                    </div>

                                </nz-option>
                            }
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-divider></nz-divider>

                <div style="display: flex; justify-content: flex-end; gap: 8px;">
                    <button nz-button nzType="default" (click)="cancelEdit()">Cancel</button>
                    <button nz-button nzType="primary" [nzLoading]="isSaving" (click)="savePackage()">Save Package</button>
                </div>
            </form>
        } @else {
             <div style="display: flex; justify-content: flex-end; gap: 8px;">
                <button nz-button nzType="default" (click)="handleCancel()">Close</button>
             </div>
            
        }

    </ng-container>
</nz-modal>